const translations = require('../../assets/configs/babel/fr.json')

window.__localization = {
  locale: 'fr',
  translations: translations
}
